// Labels and continents from countries-list; calling codes from Atlaskit:
// https://github.com/annexare/Countries
// https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
const countries = [
  { code: 'AD', label: 'Andorra', countryCallingCode: '376', continent: 'Europe' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    countryCallingCode: '971',
    continent: 'Asia',
  },
  { code: 'AF', label: 'Afghanistan', countryCallingCode: '93', continent: 'Asia' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    countryCallingCode: '1-268',
    continent: 'North America',
  },
  {
    code: 'AI',
    label: 'Anguilla',
    countryCallingCode: '1-264',
    continent: 'North America',
  },
  { code: 'AL', label: 'Albania', countryCallingCode: '355', continent: 'Europe' },
  { code: 'AM', label: 'Armenia', countryCallingCode: '374', continent: 'Asia' },
  { code: 'AO', label: 'Angola', countryCallingCode: '244', continent: 'Africa' },
  {
    code: 'AQ',
    label: 'Antarctica',
    countryCallingCode: '672',
    continent: 'Antarctica',
  },
  {
    code: 'AR',
    label: 'Argentina',
    countryCallingCode: '54',
    continent: 'South America',
  },
  {
    code: 'AS',
    label: 'American Samoa',
    countryCallingCode: '1-684',
    continent: 'Oceania',
  },
  { code: 'AT', label: 'Austria', countryCallingCode: '43', continent: 'Europe' },
  { code: 'AU', label: 'Australia', countryCallingCode: '61', continent: 'Oceania' },
  {
    code: 'AW',
    label: 'Aruba',
    countryCallingCode: '297',
    continent: 'North America',
  },
  { code: 'AX', label: 'Aland', countryCallingCode: '358', continent: 'Europe' },
  { code: 'AZ', label: 'Azerbaijan', countryCallingCode: '994', continent: 'Asia' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    countryCallingCode: '387',
    continent: 'Europe',
  },
  {
    code: 'BB',
    label: 'Barbados',
    countryCallingCode: '1-246',
    continent: 'North America',
  },
  { code: 'BD', label: 'Bangladesh', countryCallingCode: '880', continent: 'Asia' },
  { code: 'BE', label: 'Belgium', countryCallingCode: '32', continent: 'Europe' },
  {
    code: 'BF',
    label: 'Burkina Faso',
    countryCallingCode: '226',
    continent: 'Africa',
  },
  { code: 'BG', label: 'Bulgaria', countryCallingCode: '359', continent: 'Europe' },
  { code: 'BH', label: 'Bahrain', countryCallingCode: '973', continent: 'Asia' },
  { code: 'BI', label: 'Burundi', countryCallingCode: '257', continent: 'Africa' },
  { code: 'BJ', label: 'Benin', countryCallingCode: '229', continent: 'Africa' },
  {
    code: 'BL',
    label: 'Saint Barthelemy',
    countryCallingCode: '590',
    continent: 'North America',
  },
  {
    code: 'BM',
    label: 'Bermuda',
    countryCallingCode: '1-441',
    continent: 'North America',
  },
  { code: 'BN', label: 'Brunei', countryCallingCode: '673', continent: 'Asia' },
  {
    code: 'BO',
    label: 'Bolivia',
    countryCallingCode: '591',
    continent: 'South America',
  },
  {
    code: 'BR',
    label: 'Brazil',
    countryCallingCode: '55',
    continent: 'South America',
  },
  {
    code: 'BS',
    label: 'Bahamas',
    countryCallingCode: '1-242',
    continent: 'North America',
  },
  { code: 'BT', label: 'Bhutan', countryCallingCode: '975', continent: 'Asia' },
  {
    code: 'BV',
    label: 'Bouvet Island',
    countryCallingCode: '47',
    continent: 'Antarctica',
  },
  { code: 'BW', label: 'Botswana', countryCallingCode: '267', continent: 'Africa' },
  { code: 'BY', label: 'Belarus', countryCallingCode: '375', continent: 'Europe' },
  {
    code: 'BZ',
    label: 'Belize',
    countryCallingCode: '501',
    continent: 'North America',
  },
  {
    code: 'CA',
    label: 'Canada',
    countryCallingCode: '1',
    continent: 'North America',
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    countryCallingCode: '61',
    continent: 'Asia',
  },
  {
    code: 'CD',
    label: 'Democratic Republic of the Congo',
    countryCallingCode: '243',
    continent: 'Africa',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    countryCallingCode: '236',
    continent: 'Africa',
  },
  {
    code: 'CG',
    label: 'Republic of the Congo',
    countryCallingCode: '242',
    continent: 'Africa',
  },
  {
    code: 'CH',
    label: 'Switzerland',
    countryCallingCode: '41',
    continent: 'Europe',
  },
  {
    code: 'CI',
    label: 'Ivory Coast',
    countryCallingCode: '225',
    continent: 'Africa',
  },
  {
    code: 'CK',
    label: 'Cook Islands',
    countryCallingCode: '682',
    continent: 'Oceania',
  },
  {
    code: 'CL',
    label: 'Chile',
    countryCallingCode: '56',
    continent: 'South America',
  },
  { code: 'CM', label: 'Cameroon', countryCallingCode: '237', continent: 'Africa' },
  { code: 'CN', label: 'China', countryCallingCode: '86', continent: 'Asia' },
  {
    code: 'CO',
    label: 'Colombia',
    countryCallingCode: '57',
    continent: 'South America',
  },
  {
    code: 'CR',
    label: 'Costa Rica',
    countryCallingCode: '506',
    continent: 'North America',
  },
  {
    code: 'CU',
    label: 'Cuba',
    countryCallingCode: '53',
    continent: 'North America',
  },
  {
    code: 'CV',
    label: 'Cape Verde',
    countryCallingCode: '238',
    continent: 'Africa',
  },
  {
    code: 'CW',
    label: 'Curacao',
    countryCallingCode: '599',
    continent: 'North America',
  },
  {
    code: 'CX',
    label: 'Christmas Island',
    countryCallingCode: '61',
    continent: 'Asia',
  },
  { code: 'CY', label: 'Cyprus', countryCallingCode: '357', continent: 'Europe' },
  {
    code: 'CZ',
    label: 'Czech Republic',
    countryCallingCode: '420',
    continent: 'Europe',
  },
  { code: 'DE', label: 'Germany', countryCallingCode: '49', continent: 'Europe' },
  { code: 'DJ', label: 'Djibouti', countryCallingCode: '253', continent: 'Africa' },
  { code: 'DK', label: 'Denmark', countryCallingCode: '45', continent: 'Europe' },
  {
    code: 'DM',
    label: 'Dominica',
    countryCallingCode: '1-767',
    continent: 'North America',
  },
  {
    code: 'DO',
    label: 'Dominican Republic',
    countryCallingCode: '1-809',
    continent: 'North America',
  },
  { code: 'DZ', label: 'Algeria', countryCallingCode: '213', continent: 'Africa' },
  {
    code: 'EC',
    label: 'Ecuador',
    countryCallingCode: '593',
    continent: 'South America',
  },
  { code: 'EE', label: 'Estonia', countryCallingCode: '372', continent: 'Europe' },
  { code: 'EG', label: 'Egypt', countryCallingCode: '20', continent: 'Africa' },
  {
    code: 'EH',
    label: 'Western Sahara',
    countryCallingCode: '212',
    continent: 'Africa',
  },
  { code: 'ER', label: 'Eritrea', countryCallingCode: '291', continent: 'Africa' },
  { code: 'ES', label: 'Spain', countryCallingCode: '34', continent: 'Europe' },
  { code: 'ET', label: 'Ethiopia', countryCallingCode: '251', continent: 'Africa' },
  { code: 'FI', label: 'Finland', countryCallingCode: '358', continent: 'Europe' },
  { code: 'FJ', label: 'Fiji', countryCallingCode: '679', continent: 'Oceania' },
  {
    code: 'FK',
    label: 'Falkland Islands',
    countryCallingCode: '500',
    continent: 'South America',
  },
  {
    code: 'FM',
    label: 'Micronesia',
    countryCallingCode: '691',
    continent: 'Oceania',
  },
  {
    code: 'FO',
    label: 'Faroe Islands',
    countryCallingCode: '298',
    continent: 'Europe',
  },
  { code: 'FR', label: 'France', countryCallingCode: '33', continent: 'Europe' },
  { code: 'GA', label: 'Gabon', countryCallingCode: '241', continent: 'Africa' },
  {
    code: 'GB',
    label: 'United Kingdom',
    countryCallingCode: '44',
    continent: 'Europe',
  },
  {
    code: 'GD',
    label: 'Grenada',
    countryCallingCode: '1-473',
    continent: 'North America',
  },
  { code: 'GE', label: 'Georgia', countryCallingCode: '995', continent: 'Asia' },
  {
    code: 'GF',
    label: 'French Guiana',
    countryCallingCode: '594',
    continent: 'South America',
  },
  { code: 'GG', label: 'Guernsey', countryCallingCode: '44', continent: 'Europe' },
  { code: 'GH', label: 'Ghana', countryCallingCode: '233', continent: 'Africa' },
  { code: 'GI', label: 'Gibraltar', countryCallingCode: '350', continent: 'Europe' },
  {
    code: 'GL',
    label: 'Greenland',
    countryCallingCode: '299',
    continent: 'North America',
  },
  { code: 'GM', label: 'Gambia', countryCallingCode: '220', continent: 'Africa' },
  { code: 'GN', label: 'Guinea', countryCallingCode: '224', continent: 'Africa' },
  {
    code: 'GP',
    label: 'Guadeloupe',
    countryCallingCode: '590',
    continent: 'North America',
  },
  {
    code: 'GQ',
    label: 'Equatorial Guinea',
    countryCallingCode: '240',
    continent: 'Africa',
  },
  { code: 'GR', label: 'Greece', countryCallingCode: '30', continent: 'Europe' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    countryCallingCode: '500',
    continent: 'Antarctica',
  },
  {
    code: 'GT',
    label: 'Guatemala',
    countryCallingCode: '502',
    continent: 'North America',
  },
  { code: 'GU', label: 'Guam', countryCallingCode: '1-671', continent: 'Oceania' },
  {
    code: 'GW',
    label: 'Guinea-Bissau',
    countryCallingCode: '245',
    continent: 'Africa',
  },
  {
    code: 'GY',
    label: 'Guyana',
    countryCallingCode: '592',
    continent: 'South America',
  },
  { code: 'HK', label: 'Hong Kong', countryCallingCode: '852', continent: 'Asia' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    countryCallingCode: '672',
    continent: 'Antarctica',
  },
  {
    code: 'HN',
    label: 'Honduras',
    countryCallingCode: '504',
    continent: 'North America',
  },
  { code: 'HR', label: 'Croatia', countryCallingCode: '385', continent: 'Europe' },
  {
    code: 'HT',
    label: 'Haiti',
    countryCallingCode: '509',
    continent: 'North America',
  },
  { code: 'HU', label: 'Hungary', countryCallingCode: '36', continent: 'Europe' },
  { code: 'ID', label: 'Indonesia', countryCallingCode: '62', continent: 'Asia' },
  { code: 'IE', label: 'Ireland', countryCallingCode: '353', continent: 'Europe' },
  { code: 'IL', label: 'Israel', countryCallingCode: '972', continent: 'Asia' },
  {
    code: 'IM',
    label: 'Isle of Man',
    countryCallingCode: '44',
    continent: 'Europe',
  },
  { code: 'IN', label: 'India', countryCallingCode: '91', continent: 'Asia' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    countryCallingCode: '246',
    continent: 'Asia',
  },
  { code: 'IQ', label: 'Iraq', countryCallingCode: '964', continent: 'Asia' },
  { code: 'IR', label: 'Iran', countryCallingCode: '98', continent: 'Asia' },
  { code: 'IS', label: 'Iceland', countryCallingCode: '354', continent: 'Europe' },
  { code: 'IT', label: 'Italy', countryCallingCode: '39', continent: 'Europe' },
  { code: 'JE', label: 'Jersey', countryCallingCode: '44', continent: 'Europe' },
  {
    code: 'JM',
    label: 'Jamaica',
    countryCallingCode: '1-876',
    continent: 'North America',
  },
  { code: 'JO', label: 'Jordan', countryCallingCode: '962', continent: 'Asia' },
  { code: 'JP', label: 'Japan', countryCallingCode: '81', continent: 'Asia' },
  { code: 'KE', label: 'Kenya', countryCallingCode: '254', continent: 'Africa' },
  { code: 'KG', label: 'Kyrgyzstan', countryCallingCode: '996', continent: 'Asia' },
  { code: 'KH', label: 'Cambodia', countryCallingCode: '855', continent: 'Asia' },
  { code: 'KI', label: 'Kiribati', countryCallingCode: '686', continent: 'Oceania' },
  { code: 'KM', label: 'Comoros', countryCallingCode: '269', continent: 'Africa' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    countryCallingCode: '1-869',
    continent: 'North America',
  },
  { code: 'KP', label: 'North Korea', countryCallingCode: '850', continent: 'Asia' },
  { code: 'KR', label: 'South Korea', countryCallingCode: '82', continent: 'Asia' },
  { code: 'KW', label: 'Kuwait', countryCallingCode: '965', continent: 'Asia' },
  {
    code: 'KY',
    label: 'Cayman Islands',
    countryCallingCode: '1-345',
    continent: 'North America',
  },
  { code: 'KZ', label: 'Kazakhstan', countryCallingCode: '7', continent: 'Asia' },
  { code: 'LA', label: 'Laos', countryCallingCode: '856', continent: 'Asia' },
  { code: 'LB', label: 'Lebanon', countryCallingCode: '961', continent: 'Asia' },
  {
    code: 'LC',
    label: 'Saint Lucia',
    countryCallingCode: '1-758',
    continent: 'North America',
  },
  {
    code: 'LI',
    label: 'Liechtenstein',
    countryCallingCode: '423',
    continent: 'Europe',
  },
  { code: 'LK', label: 'Sri Lanka', countryCallingCode: '94', continent: 'Asia' },
  { code: 'LR', label: 'Liberia', countryCallingCode: '231', continent: 'Africa' },
  { code: 'LS', label: 'Lesotho', countryCallingCode: '266', continent: 'Africa' },
  { code: 'LT', label: 'Lithuania', countryCallingCode: '370', continent: 'Europe' },
  {
    code: 'LU',
    label: 'Luxembourg',
    countryCallingCode: '352',
    continent: 'Europe',
  },
  { code: 'LV', label: 'Latvia', countryCallingCode: '371', continent: 'Europe' },
  { code: 'LY', label: 'Libya', countryCallingCode: '218', continent: 'Africa' },
  { code: 'MA', label: 'Morocco', countryCallingCode: '212', continent: 'Africa' },
  { code: 'MC', label: 'Monaco', countryCallingCode: '377', continent: 'Europe' },
  { code: 'MD', label: 'Moldova', countryCallingCode: '373', continent: 'Europe' },
  {
    code: 'ME',
    label: 'Montenegro',
    countryCallingCode: '382',
    continent: 'Europe',
  },
  {
    code: 'MF',
    label: 'Saint Martin',
    countryCallingCode: '590',
    continent: 'North America',
  },
  {
    code: 'MG',
    label: 'Madagascar',
    countryCallingCode: '261',
    continent: 'Africa',
  },
  {
    code: 'MH',
    label: 'Marshall Islands',
    countryCallingCode: '692',
    continent: 'Oceania',
  },
  {
    code: 'MK',
    label: 'North Macedonia',
    countryCallingCode: '389',
    continent: 'Europe',
  },
  { code: 'ML', label: 'Mali', countryCallingCode: '223', continent: 'Africa' },
  {
    code: 'MM',
    label: 'Myanmar (Burma)',
    countryCallingCode: '95',
    continent: 'Asia',
  },
  { code: 'MN', label: 'Mongolia', countryCallingCode: '976', continent: 'Asia' },
  { code: 'MO', label: 'Macao', countryCallingCode: '853', continent: 'Asia' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    countryCallingCode: '1-670',
    continent: 'Oceania',
  },
  {
    code: 'MQ',
    label: 'Martinique',
    countryCallingCode: '596',
    continent: 'North America',
  },
  {
    code: 'MR',
    label: 'Mauritania',
    countryCallingCode: '222',
    continent: 'Africa',
  },
  {
    code: 'MS',
    label: 'Montserrat',
    countryCallingCode: '1-664',
    continent: 'North America',
  },
  { code: 'MT', label: 'Malta', countryCallingCode: '356', continent: 'Europe' },
  { code: 'MU', label: 'Mauritius', countryCallingCode: '230', continent: 'Africa' },
  { code: 'MV', label: 'Maldives', countryCallingCode: '960', continent: 'Asia' },
  { code: 'MW', label: 'Malawi', countryCallingCode: '265', continent: 'Africa' },
  {
    code: 'MX',
    label: 'Mexico',
    countryCallingCode: '52',
    continent: 'North America',
  },
  { code: 'MY', label: 'Malaysia', countryCallingCode: '60', continent: 'Asia' },
  {
    code: 'MZ',
    label: 'Mozambique',
    countryCallingCode: '258',
    continent: 'Africa',
  },
  { code: 'NA', label: 'Namibia', countryCallingCode: '264', continent: 'Africa' },
  {
    code: 'NC',
    label: 'New Caledonia',
    countryCallingCode: '687',
    continent: 'Oceania',
  },
  { code: 'NE', label: 'Niger', countryCallingCode: '227', continent: 'Africa' },
  {
    code: 'NF',
    label: 'Norfolk Island',
    countryCallingCode: '672',
    continent: 'Oceania',
  },
  { code: 'NG', label: 'Nigeria', countryCallingCode: '234', continent: 'Africa' },
  {
    code: 'NI',
    label: 'Nicaragua',
    countryCallingCode: '505',
    continent: 'North America',
  },
  {
    code: 'NL',
    label: 'Netherlands',
    countryCallingCode: '31',
    continent: 'Europe',
  },
  { code: 'NO', label: 'Norway', countryCallingCode: '47', continent: 'Europe' },
  { code: 'NP', label: 'Nepal', countryCallingCode: '977', continent: 'Asia' },
  { code: 'NR', label: 'Nauru', countryCallingCode: '674', continent: 'Oceania' },
  { code: 'NU', label: 'Niue', countryCallingCode: '683', continent: 'Oceania' },
  {
    code: 'NZ',
    label: 'New Zealand',
    countryCallingCode: '64',
    continent: 'Oceania',
  },
  { code: 'OM', label: 'Oman', countryCallingCode: '968', continent: 'Asia' },
  {
    code: 'PA',
    label: 'Panama',
    countryCallingCode: '507',
    continent: 'North America',
  },
  {
    code: 'PE',
    label: 'Peru',
    countryCallingCode: '51',
    continent: 'South America',
  },
  {
    code: 'PF',
    label: 'French Polynesia',
    countryCallingCode: '689',
    continent: 'Oceania',
  },
  {
    code: 'PG',
    label: 'Papua New Guinea',
    countryCallingCode: '675',
    continent: 'Oceania',
  },
  { code: 'PH', label: 'Philippines', countryCallingCode: '63', continent: 'Asia' },
  { code: 'PK', label: 'Pakistan', countryCallingCode: '92', continent: 'Asia' },
  { code: 'PL', label: 'Poland', countryCallingCode: '48', continent: 'Europe' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    countryCallingCode: '508',
    continent: 'North America',
  },
  {
    code: 'PN',
    label: 'Pitcairn Islands',
    countryCallingCode: '870',
    continent: 'Oceania',
  },
  {
    code: 'PR',
    label: 'Puerto Rico',
    countryCallingCode: '1',
    continent: 'North America',
  },
  { code: 'PS', label: 'Palestine', countryCallingCode: '970', continent: 'Asia' },
  { code: 'PT', label: 'Portugal', countryCallingCode: '351', continent: 'Europe' },
  { code: 'PW', label: 'Palau', countryCallingCode: '680', continent: 'Oceania' },
  {
    code: 'PY',
    label: 'Paraguay',
    countryCallingCode: '595',
    continent: 'South America',
  },
  { code: 'QA', label: 'Qatar', countryCallingCode: '974', continent: 'Asia' },
  { code: 'RE', label: 'Reunion', countryCallingCode: '262', continent: 'Africa' },
  { code: 'RO', label: 'Romania', countryCallingCode: '40', continent: 'Europe' },
  { code: 'RS', label: 'Serbia', countryCallingCode: '381', continent: 'Europe' },
  { code: 'RU', label: 'Russia', countryCallingCode: '7', continent: 'Asia' },
  { code: 'RW', label: 'Rwanda', countryCallingCode: '250', continent: 'Africa' },
  {
    code: 'SA',
    label: 'Saudi Arabia',
    countryCallingCode: '966',
    continent: 'Asia',
  },
  {
    code: 'SB',
    label: 'Solomon Islands',
    countryCallingCode: '677',
    continent: 'Oceania',
  },
  {
    code: 'SC',
    label: 'Seychelles',
    countryCallingCode: '248',
    continent: 'Africa',
  },
  { code: 'SD', label: 'Sudan', countryCallingCode: '249', continent: 'Africa' },
  { code: 'SE', label: 'Sweden', countryCallingCode: '46', continent: 'Europe' },
  { code: 'SG', label: 'Singapore', countryCallingCode: '65', continent: 'Asia' },
  {
    code: 'SH',
    label: 'Saint Helena',
    countryCallingCode: '290',
    continent: 'Africa',
  },
  { code: 'SI', label: 'Slovenia', countryCallingCode: '386', continent: 'Europe' },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    countryCallingCode: '47',
    continent: 'Europe',
  },
  { code: 'SK', label: 'Slovakia', countryCallingCode: '421', continent: 'Europe' },
  {
    code: 'SL',
    label: 'Sierra Leone',
    countryCallingCode: '232',
    continent: 'Africa',
  },
  {
    code: 'SM',
    label: 'San Marino',
    countryCallingCode: '378',
    continent: 'Europe',
  },
  { code: 'SN', label: 'Senegal', countryCallingCode: '221', continent: 'Africa' },
  { code: 'SO', label: 'Somalia', countryCallingCode: '252', continent: 'Africa' },
  {
    code: 'SR',
    label: 'Suriname',
    countryCallingCode: '597',
    continent: 'South America',
  },
  {
    code: 'SS',
    label: 'South Sudan',
    countryCallingCode: '211',
    continent: 'Africa',
  },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    countryCallingCode: '239',
    continent: 'Africa',
  },
  {
    code: 'SV',
    label: 'El Salvador',
    countryCallingCode: '503',
    continent: 'North America',
  },
  {
    code: 'SX',
    label: 'Sint Maarten',
    countryCallingCode: '1-721',
    continent: 'North America',
  },
  { code: 'SY', label: 'Syria', countryCallingCode: '963', continent: 'Asia' },
  { code: 'SZ', label: 'Eswatini', countryCallingCode: '268', continent: 'Africa' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    countryCallingCode: '1-649',
    continent: 'North America',
  },
  { code: 'TD', label: 'Chad', countryCallingCode: '235', continent: 'Africa' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    countryCallingCode: '262',
    continent: 'Antarctica',
  },
  { code: 'TG', label: 'Togo', countryCallingCode: '228', continent: 'Africa' },
  { code: 'TH', label: 'Thailand', countryCallingCode: '66', continent: 'Asia' },
  { code: 'TJ', label: 'Tajikistan', countryCallingCode: '992', continent: 'Asia' },
  { code: 'TK', label: 'Tokelau', countryCallingCode: '690', continent: 'Oceania' },
  {
    code: 'TL',
    label: 'East Timor',
    countryCallingCode: '670',
    continent: 'Oceania',
  },
  {
    code: 'TM',
    label: 'Turkmenistan',
    countryCallingCode: '993',
    continent: 'Asia',
  },
  { code: 'TN', label: 'Tunisia', countryCallingCode: '216', continent: 'Africa' },
  { code: 'TO', label: 'Tonga', countryCallingCode: '676', continent: 'Oceania' },
  { code: 'TR', label: 'Türkiye', countryCallingCode: '90', continent: 'Asia' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    countryCallingCode: '1-868',
    continent: 'North America',
  },
  { code: 'TV', label: 'Tuvalu', countryCallingCode: '688', continent: 'Oceania' },
  { code: 'TW', label: 'Taiwan', countryCallingCode: '886', continent: 'Asia' },
  { code: 'TZ', label: 'Tanzania', countryCallingCode: '255', continent: 'Africa' },
  { code: 'UA', label: 'Ukraine', countryCallingCode: '380', continent: 'Europe' },
  { code: 'UG', label: 'Uganda', countryCallingCode: '256', continent: 'Africa' },
  {
    code: 'US',
    label: 'United States',
    countryCallingCode: '1',
    continent: 'North America',
  },
  {
    code: 'UY',
    label: 'Uruguay',
    countryCallingCode: '598',
    continent: 'South America',
  },
  { code: 'UZ', label: 'Uzbekistan', countryCallingCode: '998', continent: 'Asia' },
  {
    code: 'VA',
    label: 'Vatican City',
    countryCallingCode: '379',
    continent: 'Europe',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    countryCallingCode: '1-784',
    continent: 'North America',
  },
  {
    code: 'VE',
    label: 'Venezuela',
    countryCallingCode: '58',
    continent: 'South America',
  },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    countryCallingCode: '1-284',
    continent: 'North America',
  },
  {
    code: 'VI',
    label: 'U.S. Virgin Islands',
    countryCallingCode: '1-340',
    continent: 'North America',
  },
  { code: 'VN', label: 'Vietnam', countryCallingCode: '84', continent: 'Asia' },
  { code: 'VU', label: 'Vanuatu', countryCallingCode: '678', continent: 'Oceania' },
  {
    code: 'WF',
    label: 'Wallis and Futuna',
    countryCallingCode: '681',
    continent: 'Oceania',
  },
  { code: 'WS', label: 'Samoa', countryCallingCode: '685', continent: 'Oceania' },
  { code: 'XK', label: 'Kosovo', countryCallingCode: '383', continent: 'Europe' },
  { code: 'YE', label: 'Yemen', countryCallingCode: '967', continent: 'Asia' },
  { code: 'YT', label: 'Mayotte', countryCallingCode: '262', continent: 'Africa' },
  {
    code: 'ZA',
    label: 'South Africa',
    countryCallingCode: '27',
    continent: 'Africa',
  },
  { code: 'ZM', label: 'Zambia', countryCallingCode: '260', continent: 'Africa' },
  { code: 'ZW', label: 'Zimbabwe', countryCallingCode: '263', continent: 'Africa' },
];

export default countries;
